<template>
  <h-dialog
    v-model="rangeDetailDialog"
    @onCancel="rangeDetailDialog = false"
    width="700px"
    destroy-on-close
    :title="$t('productModules.priceManagement.applicationScope')"
    :footer="false"
  >
    <div class="range-detail-dialog">
      <span>*</span>{{ $t('productModules.priceManagement.applicationScope') }}：{{ range === 1 ? $t('productModules.priceManagement.someStores') : $t('productModules.priceManagement.org') }}
    </div>
    <h-simple-table
      style="margin: 0;padding: 0;"
      v-if="range === 1"
      :columns="columns"
      :dataSource="dataSource"
      row-key="id"
      :pagination="{
        layout: 'prev, pager, next',
        pageSize: 5,
        pagerCount: 5
      }"
    ></h-simple-table>
    <el-tree
      v-else
      class="tree"
      ref="treeRef"
      :props="defaultProps"
      show-checkbox
      check-strictly
      node-key="id"
      :data="orgList"
      :default-checked-keys="defaultCheckedKeys"
      :default-expanded-keys="defaultCheckedKeys"
    />
  </h-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { apiSelectPriceStrategyOrg, apiSelectPriceStrategyShop } from '@/api/goods-manager/price-strategy'
import { getTreeList } from '@/api/common'
import { $t } from '@/i18n';

//抛出方法
defineExpose({
  showDetail
})

const columns = [
  {
    prop: 'shop_name',
    label: $t('storeModules.operationLog.storeName')
  },
  {
    prop: 'cabinet_code',
    label: $t('storeModules.operationLog.cabinetId')
  },
  {
    prop: 'org_name',
    label: $t('common.org')
  }
]

const rangeDetailDialog = ref(false)
const dataSource = ref([])
const defaultProps = {
  label: 'name',
  children: 'org_list',
  disabled: 'disabled'
}
//默认展开的节点key
const defaultCheckedKeys = ref([])
const treeRef = ref()
const orgList = ref([])
const range = ref(null)

async function showDetail(row) {
  range.value = row.range
  if (row.range === 1) {
    await getShop(row.id)
  }
  if (row.range === 3) {
    await getOrgList(row.id)
  }
  rangeDetailDialog.value = true
}

// 部分店铺 1
async function getShop(_id) {
  const { result } = await apiSelectPriceStrategyShop(_id)
  if (result) {
    dataSource.value = result.data.rows
  }
}

// 部分组织 3
async function getOrgList(_id) {
  const { result } = await getTreeList()
  if (result) {
    orgList.value = addDisabledToTree([result.data])
  }
  const { result: rs } = await apiSelectPriceStrategyOrg(_id)
  if (rs) {
    defaultCheckedKeys.value = rs.data.rows.map((item) => item.id)
  }
}

function addDisabledToTree(_orgList) {
  let orgList = _orgList
  orgList.forEach((item) => {
    item.disabled = true
    if (item.org_list && item.org_list.length > 0) {
      addDisabledToTree(item.org_list)
    }
  })
  return orgList
}
</script>
<style lang="scss" scoped>
.x-table-page {

}

.range-detail-dialog {
  border-radius: 8px 8px 8px 8px;
  background-color: var(--tips-background-color);
  border: 1px solid var(--tips-border-color);
  height: 46px;
  color: #151515;
  font-size: 14px;
  line-height: 46px;
  padding-left: 14px;
  box-sizing: border-box;
  margin-bottom: 20px;


  span {
    color: #fe223b;
  }

}


</style>
